import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { fundStatusLabel, fundStatusColor } from "../../helpers/fund";

const Result = ({ result, titleOverride }) => {
  if (!result || !result.permalink) {
    return null;
  }

  // Prefer WP title when available; fall back to API fields
  const label =
    (titleOverride && String(titleOverride).trim()) ||
    result.Fund_Name ||
    result.Disease ||
    "View fund";

  // Format Assistance_Amount as whole-dollar currency with commas
  function formatCurrency(value) {
    if (value == null) return "—";
    var num = parseFloat(value);
    if (isNaN(num)) return "—";
    return num.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  }

  return (
    <Fragment>
      <li className="QuickSearch-results-item f-scale-body">
        <a href={result.permalink} className="QuickSearch-results-link">
          <span>{label}</span>
          <span>{formatCurrency(result.Assistance_Amount)}</span>
          <span
            className={`QuickSearch-results-status f-label-small c-${fundStatusColor(
              result
            )}`}
          >
            {fundStatusLabel(result)}
          </span>
        </a>
      </li>
    </Fragment>
  );
};

Result.propTypes = {
  result: PropTypes.object.isRequired,
  titleOverride: PropTypes.string,
};

export default Result;
